export enum StratalotTodoApplicationEnum {
  'Acte estimation' = 'Acte estimation',
  'Vacance' = 'Vacance',
  'Fin travaux' = 'Fin travaux',
  'Livraison' = 'Livraison'
}
